import {
  ADD_PALLETE_SAGA,
  DELETE_PALLETE_SAGA,
  EDIT_PALLETE_SAGA,
  PALLETE_ADDED,
  PALLETE_DELETED,
  PALLETE_EDITED,
  END_LOADING,
  GET_MATERIALS_SAGA,
  GET_PALLETES_SAGA,
  MATERIALS_FETCHED,
  PALLETES_FETCHED,
} from "../actionTypes";

const INITIAL_STATE = {
  palletesList: [],
  materialsList: [],
  loading: false,
};

const palleteReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  const handleDeleteItem = (id) => {
    const oldList = JSON.parse(JSON.stringify(state.palletesList));
    const newList = oldList.filter((item) => item.id !== id);
    return newList;
  };

  const handleEditItem = ({ id, price }) => {
    const oldList = JSON.parse(JSON.stringify(state.palletesList));
    const index = oldList.findIndex((item) => item.id === id);
    oldList[index].pricePerMeter = price;
    return oldList;
  };

  const handleAddPallete = (data) => {
    console.log(
      state.materialsList.find((item) => item?.id === data.materialId)?.name
    );

    const newList = [
      ...state.palletesList,
      {
        ...data,
        materialName: state.materialsList.find(
          (item) => item?.id === data.materialId
        )?.name,
        id: Math.random() * -1000,
      },
    ];
    return newList;
  };

  switch (type) {
    case MATERIALS_FETCHED:
      return {
        ...state,
        materialsList: payload,
        loading: false,
      };
    case PALLETES_FETCHED:
      return {
        ...state,
        palletesList: payload,
        loading: false,
      };
    case GET_PALLETES_SAGA:
      return {
        ...state,
        loading: true,
      };
    case GET_MATERIALS_SAGA:
      return {
        ...state,
        loading: false,
      };
    case END_LOADING:
      return {
        ...state,
        loading: false,
      };
    case ADD_PALLETE_SAGA:
      return {
        ...state,
        loading: true,
      };
    case DELETE_PALLETE_SAGA:
      return {
        ...state,
        loading: true,
      };
    case EDIT_PALLETE_SAGA:
      return {
        ...state,
        loading: true,
      };
    case PALLETE_ADDED:
      return {
        ...state,
        loading: false,
      };
    case PALLETE_DELETED:
      return {
        ...state,
        palletesList: handleDeleteItem(payload),
        loading: false,
      };
    case PALLETE_EDITED:
      return {
        ...state,
        palletesList: handleEditItem(payload),
        loading: false,
      };
    default:
      return state;
  }
};

export default palleteReducer;
